export var containerPadding = {
  "@media (min-width: 768px)": {
    "paddingLeft": "5%",
    "paddingRight": "5%"
  },
  "@media (min-width: 1024px)": {
    "paddingLeft": "10%",
    "paddingRight": "10%"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "13%",
    "paddingRight": "13%"
  }
};